export const SKINS = {
  standard: 'standard',
  dark: 'dark',
  inverted: 'inverted',
  destructive: 'destructive',
  success: 'success',
} as const;

export const SHAPES = {
  square: 'square',
  round: 'round',
  pill: 'pill',
} as const;

export const PRIORITY = {
  primary: 'primary',
} as const;

export const iconChildSize = {
  tiny: '18px',
  small: '18px',
  medium: '24px',
  large: '24px',
} as const;

const prefix = 'toggle-button' as const;

export const dataHooks = {
  label: `${prefix}-label`,
  button: `${prefix}-button`,
} as const;

export const dataAttr = {
  selected: 'data-selected',
  skin: 'data-skin',
  placement: 'data-placement',
  shape: 'data-shape',
} as const;

export const testStories = {
  ToggleButton_SKINS: 'ToggleButton skins',
} as const;

export const testDataHooks = {
  iconOfToggleButton: 'toggleButton-icon',
} as const;

export const pillTextSizesMap = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'medium',
} as const;
